<template>
  <div v-if="documentEntryWrapper">
    <p>
      <v-btn :to="documentTemplateLink">
        <v-icon>chevron_left</v-icon>Change templates
      </v-btn>
    </p>
    <h1>Create new document</h1>
    <FileWorking :file="file" />
    <v-card v-if="entities" class="entities">
      <v-card-text>
        <strong>Concerning:</strong>
        <EntityZ v-for="entity in entities" :key="entity.id" :entity="entity" />
      </v-card-text>
    </v-card>
    <v-alert :value="true" type="info">Fill in the document</v-alert>
    <div
      class="document"
      v-for="(
        documentEntryItem, index
      ) in documentEntryWrapper.documentEntryItems"
      :key="index"
    >
      <TemplateLink :template="documentEntryItem.template" />
      <table v-if="documentEntryItem.template.headerid == 1">
        <tr>
          <th>Our reference</th>
          <td>{{ file.referencelong }}</td>
        </tr>
        <tr>
          <th>Your reference</th>
          <td>
            <v-text-field v-model="documentEntryItem.reference" />
          </td>
        </tr>
        <tr>
          <th>Custom date</th>
          <td>
            <DateDropdown v-model="documentEntryItem.customdate" />
          </td>
        </tr>
      </table>
      <document-element
        v-if="documentEntryItem.show"
        :documentElement="documentEntryItem.documentElement"
        :entryItems="documentEntryItem.entryItems"
        :fill="false"
        @updated="updated($event, index)"
      />
      <template v-if="!documentEntryItem.show">
        <span>Document not shown as no parameters to fill.</span>
        <a @click="documentEntryItem.show = true">Click to show</a>
      </template>
      <!-- <template v-if="documentEntryItem.show">
      <a @click="documentEntryItem.show = false">Click to hide</a>
      </template>-->
    </div>
    <div class="document" v-for="upload in uploads" :key="upload.id">
      <strong>
        <span v-if="!$keycloak.hasRealmRole('documentadmin')">
          <span v-if="upload.uploadDescription">{{
            upload.uploadDescription.body
          }}</span>
          <span v-if="!upload.uploadDescription">{{
            upload.uploadDescription.id
          }}</span>
        </span>
        <router-link
          :to="{ name: 'uploadCommon', params: { id: upload.id } }"
          v-if="$keycloak.hasRealmRole('documentadmin')"
        >
          <span v-if="upload.uploadDescription">{{
            upload.uploadDescription.body
          }}</span>
          <span v-if="!upload.uploadDescription">{{
            upload.uploadDescription.id
          }}</span>
        </router-link>
      </strong>
    </div>
    <v-btn
      :disabled="savingDocuments"
      :loading="savingDocuments"
      @click="saveDocuments"
    >
      Save documents and continue
      <v-icon>save</v-icon>
    </v-btn>
    <v-dialog v-model="savingDocuments" persistent width="300">
      <v-card color="error" dark>
        <v-card-text>
          <span>Waiting for server to save documents...</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-alert :value="feedback" type="error">{{ feedback }}</v-alert>
  </div>
</template>

<script>
import CREATE_UPLOAD_FILES from "@/graphql/document/CreateUploadFiles";
import DateDropdown from "@/components/date/DateDropdown";
import EntityZ from "@/components/link/EntityZ";
import FileWorking from "@/components/link/FileWorking";
import TemplateLink from "@/components/document/TemplateLink";
// import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Document",
  metaInfo() {
    return {
      title: "Document",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    DateDropdown,
    EntityZ,
    FileWorking,
    TemplateLink
  },
  computed: {
    documentTemplateLink() {
      return {
        name: "documentTemplate",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId,
          entityTypeId: this.$route.params.entityTypeId,
          entities: this.$route.params.entities
        }
      };
    }
  },
  data() {
    return {
      entities: null,
      file: null,
      feedback: null,
      documentEntryWrapper: null,
      uploads: null,
      documentIds: null,
      uploadFileIds: null,
      savingDocuments: false
    };
  },
  methods: {
    async fetchEntities() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/multiple/${this.$route.params.entities}`
      );
      // console.log(response.data);
      this.entities = response.data;
    },
    async fetchFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}`
      );
      // console.log(response.data);
      this.file = response.data;
    },
    async fetchDocumentEntryWrapper() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}/documentEntryWrapper/${this.$route.params.entityTypeId}/${this.$route.params.entities}/${this.$route.query.templates}`
      );
      // console.log(response.data);
      this.documentEntryWrapper = response.data;
    },
    async fetchUploads() {
      const response = await nbmlaw.get(
        `/cors/admin/document/uploads/multiple/${this.$route.query.uploads}`
      );
      // console.log(response.data);
      this.uploads = response.data;
    },
    updated(event, index) {
      // let copy = Object.assign({}, this.documentEntryWrapper);
      let copy = JSON.parse(JSON.stringify(this.documentEntryWrapper));
      copy.documentEntryItems[index].entryItems = event;
      this.documentEntryWrapper = copy;
      // console.log(copy);
    },
    async saveDocuments() {
      this.savingDocuments = true;
      // objectValues(this.documentEntryWrapper);
      if (this.$route.query.templates && this.$route.query.templates.length) {
        const responseDocuments = await nbmlaw.post(
          `/cors/admin/file/files/${this.$route.params.objectId}/documentEntryWrapper/${this.$route.params.entityTypeId}/${this.$route.params.entities}/${this.$route.query.templates}`,
          this.documentEntryWrapper
        );
        this.documentIds = responseDocuments.data;
      }
      if (this.$route.query.uploads && this.$route.query.uploads.length) {
        const uploadids = this.$route.query.uploads.split(".").map(Number);
        const responseUploads = await this.$apollo.mutate({
          mutation: CREATE_UPLOAD_FILES,
          variables: {
            id: Number(this.$route.params.objectId),
            uploadids
          }
        });
        this.uploadFileIds = responseUploads.data.createUploadFiles;
      }
      this.redirect();
    },
    redirect() {
      this.savingDocuments = false;
      const documents = this.documentIds
        ? this.documentIds.join(".")
        : undefined;
      const uploads = this.uploadFileIds
        ? this.uploadFileIds.join(".")
        : undefined;
      this.$router.push({
        name: "documentEmail",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId,
          entityTypeId: this.$route.params.entityTypeId,
          entities: this.$route.params.entities
        },
        query: {
          documents,
          uploads
        }
      });
    }
  },
  created() {
    this.fetchEntities();
    this.fetchFile();
    this.fetchDocumentEntryWrapper();
    if (this.$route.query.uploads) {
      this.fetchUploads();
    }
  }
};
</script>

<style>
</style>
